import React, { Component } from 'react';
import Util from '../../utils';

class Privacy extends Component {
    constructor(props){
        super(props)

        //set all pages
        window.isMain = false
    }

    componentDidMount(){
        this.props.setLoadingFinished()
        Util.scrollToTop();
    }

    render(){
        return (
            <div className={'doc'}>
                <div className="content-title">
                    <h1>Privacy policy</h1>
                    <span>Last update : 2018-12-01 (YYYY-MM-DD)</span>
                </div>
                <div className="content-area">
                    <section>
                        <h2>1. General</h2>
                        <ol>
                            <li>1) This Privacy Policy document describes :
                                <ul>
                                    <li>what kind of information, the company “Jaehyun Kang” (“I”, “my", or “me”) collect,</li>
                                    <li>how to use it, which includes how long and where I keep it,</li>
                                    <li>share it,</li>
                                    <li>your rights,</li>
                                    <li>update of this document, and</li>
                                    <li>contact detail</li>
                                </ul>
                            </li>
                            <li>2) Personal Information or Data(“Information”) should be considered as personally identifiable data that is not publicly available, including things such as name or email address.
                            </li>
                            <li>3) The following terms apply to all Products (This implies any software, services, application and websites) facilitated by me.</li>
                        </ol>
                    </section>
                    <section>
                        <h2>2. Type of Information collected</h2>
                        <ol>
                            <li>1) Information - i.e. name, location, profile image or sex - may be freely provided by you, or, in case of usage information - your IP address and your URL of choice, collected automatically when using my Products.</li>
                            <li>2) Unless specified otherwise, all InformatIon requested by my Products is mandatory and failure to provide it may make it impossible for my Products to provide its services. In cases where my Product specifically states that some Information is not mandatory, you are free not to communicate this Information without consequences to the availability or the functioning of the service.</li>
                            <li>3) Feel free to contact me if you are not uncertain about which Information is mandatory.</li>
                            <li>4) You are responsible for any third-party Information obtained, published or shared through my Products and confirm that you have the third party's consent to provide the Information to me.</li>
                        </ol>
                    </section>
                    <section>
                        <h2>3. Usage of Information</h2>
                        <ol>
                            <li>1) Uses the Information only for general purposes, such as customization of advertising and content, improvement of services, collect app crashes and research.</li>
                            <li>2) Information that we process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.</li>
                            <li>3) I will retain your Information as follows:
                                <ol>
                                    <li>a. Website analytics data will be retained for a minimum period of 48 hours following the initial acquisition of data and for a maximum period of one-year following the initial acquisition of data.</li>
                                </ol>
                            </li>
                        </ol>
                    </section>
                    <section>
                        <h2>4. Sharing information</h2>
                        <ol>
                            <li>1) I may disclose your Information to our insurers and/or professional advisers insofar as reasonably necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, obtaining professional advice, or the establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.</li>
                            <li>2) In addition to the specific disclosures of Information set out in this Section 4, I may disclose your Information where such disclosure is necessary for compliance with a legal obligation to which I am subject, or in order to protect your vital interests or the vital interests of another natural person. I may also disclose your Information where such disclosure is necessary for the establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.</li>
                            <li>3) I provide information about the circumstances in which your Information may be transferred to countries outside the European Economic Area (EEA).</li>
                        </ol>
                    </section>
                    <section>
                        <h2>5. Your Rights</h2>
                        <ol>
                            <li>1) I have summarized the rights that you have under data protection law. Some of the rights are complex, and not all of the details have been included in my summaries. Accordingly, you should read the relevant laws and guidance from the regulatory authorities for a full explanation of these rights.</li>
                            <li>2) In particular, you have the right to do the following:
                                <ol>
                                    <li>a. the right to access</li>
                                    <li>b. the right to rectification</li>
                                    <li>c. the right to erasure</li>
                                    <li>d. the right to restrict processing</li>
                                    <li>e. the right to object to processing</li>
                                    <li>f. the right to data portability</li>
                                    <li>g. the right to complain to a supervisory authority; and</li>
                                    <li>h. the right to withdraw consent</li>
                                </ol>
                            </li>
                            <li>
                                4) <b>If you visit or use my Products in European Enonomic Area, below rights also apply to you :</b>
                                <ol>
                                    <li>a. For the purposes of applicable EU data protection law (including the General Data Protection Regulation 2016/679 (the “GDPR”), I am a ‘data controller’ of your Information.</li>
                                    <li>b. You are also entitled to ask us to port your Information (i.e. to transfer in a structured, commonly used and machine-readable format, to you), to erase it, or restrict its processing. You also have rights to object to some processing that is based on our legitimate interests, such as profiling that I perform for the purposes of direct marketing, and, where I have asked for your consent to process your data, to withdraw this consent as more fully described below.</li>
                                    <li>c. These rights are limited in some situations – for example, I can demonstrate that I have a legal requirement to process your Information. In some instances, this means that I may retain some Information even if you withdraw your consent.</li>
                                    <li>d. Where I require your Information to comply with legal or contractual obligations, then provision of such data is mandatory: if such data is not provided, then I will not be able to manage our contractual relationship with you, or to meet obligations placed on me. In all other cases, provision of requested Information is optional.</li>
                                    <li>e. If you have unresolved concerns you also have the right to complain to data protection authorities. The relevant data protection authority will be the data protection authority of the country:
                                        <ol>
                                            <li>i) of your habitual residence;</li>
                                            <li>ii) of your place of work; or</li>
                                            <li>iii) in which you consider the alleged infringement has occurred.</li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </section>
                    <section>
                        <h2>6. Update of this document</h2>
                        <ol>
                            <li>1) I reserves the right to make changes to this Privacy Policy at any time by giving notice to you on this page and possibly within my Products and/or - as far as technically and legally feasible - sending a notice to you via any contact information available to me. It is strongly recommended to check this page often, referring to the date of the last modification listed at the top.</li>
                            <li>2) Should the changes affect processing activities performed on the basis of your consent, I shall collect new consent from you, where required.</li>
                        </ol>
                    </section>
                    <section>
                        <h2>7. Contact Detail</h2>
                        <ol>
                            <li>1) You can contact me by following email, or using the email address published in my Products.<br/>
                                <a href="mailto:suppoert-keeper-b@heemangforyou.com">suppoert-keeper-b@heemangforyou.com</a>
                            </li>
                        </ol>
                    </section>
                </div>
            </div>
        )
    }
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/component/policies/privacy.js